import React, { FC } from 'react';
import ModalDialog from '../../@shared/modalDialog';
import OverlayCarouselPopup from '../../@shared/overlayCarouselPopup';
import { TVideoPopup } from '../types/productSeriesDetailTestimonial.types';

const VideoPopup: FC<TVideoPopup> = (props) => {
  const { useVideo, showOverlay, closeOverlayModal, getOverlayProps } = props;
  if (useVideo) {
    return (
      <ModalDialog isOpen={showOverlay} close={closeOverlayModal}>
        <OverlayCarouselPopup slides={getOverlayProps()} />
      </ModalDialog>
    );
  }
  return null;
};

export default VideoPopup;
